import { render, staticRenderFns } from "./waste-management.vue?vue&type=template&id=1448eceb&scoped=true&"
import script from "./waste-management.vue?vue&type=script&lang=js&"
export * from "./waste-management.vue?vue&type=script&lang=js&"
import style0 from "./waste-management.vue?vue&type=style&index=0&id=1448eceb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1448eceb",
  null
  
)

export default component.exports